<template>
    <div class="iframe" :id="options.id" v-show="!options.hidden" :style="{height:getHeight()}">
        <iframe :src="options.src"></iframe>
    </div>
</template>

<script>
export default {
    props: {
        options: Object
    },
    methods: {
        getHeight() {
            return (
                this.options.height +
                (typeof this.options.height === "string" ? "" : "px")
            );
        }
    }
};
</script>

<style scoped>
.iframe {
    min-height: 100px;
}
.iframe iframe {
    border: none;
    width: 100%;
    height: 100%;
}
</style>